import { atom } from 'jotai';

const debuggerAtom = atom(false);

// The devtools label is attached inside the declaration rather than by a
// module-scope statement, because this package promises `sideEffects: false`.
// The guard stays: a suite with a lightweight `jotai` stub hands back a
// non-object here, and `Object.assign` returns the atom it was given, so the
// atom identity is the same one either way.
export const showPageEditorInternalHtmlDebuggerAtom =
  typeof debuggerAtom === 'object' && debuggerAtom !== null
    ? Object.assign(debuggerAtom, {
        debugLabel: 'showPageEditorInternalHtmlDebuggerAtom',
      })
    : debuggerAtom;
